module.exports = "<i [innerHTML]=\"currentIcon\"></i>\n"